import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { LayoutGrid } from "lucide-react";
import AppStoreMenuItem from "Components/AppStoreMenuItem/AppStoreMenuItem";

const popularApps = [
    {
        id: "Trucare Provider Management",
        title: "TruCred",
        description: "Credentialing management",
        iconClassName: "bg-white border border-gray-200",
        iconChildren: <img src="/trucare-favicon.png" alt="TruCare logo" className="h-10 w-10 object-contain" />,
        link: "https://credapp.gettrucare.com/",
    },
    // {
    //     id: "Trucare Provider Management",
    //     title: "TruCred",
    //     description: "Credentialing management",
    //     iconClassName: "bg-white border border-gray-200",
    //     iconChildren: <img src="/trucare-favicon.png" alt="TruCare logo" className="h-8 w-8 object-contain" />,
    //     link: "https://credapp.gettrucare.com/",
    // },

];


const appStoreItemClass =
    "flex w-full cursor-pointer select-none rounded-lg px-3 py-2.5 outline-none transition " +
    "data-[highlighted]:bg-[#eef6ff] data-[highlighted]:ring-2 data-[highlighted]:ring-[#b3d9ff] " +
    "data-[highlighted]:ring-offset-0";

const AppStore = () => {
    const handleAppSelect = (id) => {
        // Wire navigation or modals when integrations exist
        console.log("app selected:", id);
    }; 

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger
                aria-label="Open app store"
                className="inline-flex h-8 w-8 items-center justify-center rounded-md text-[#889AB3] outline-none transition-colors duration-150 hover:bg-[#F3F4F7] hover:text-[#404D60]"
            >
                <LayoutGrid size={16} strokeWidth={1.7} />
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    align="end"
                    sideOffset={10}
                    className="z-50 min-w-[200px] max-w-[300px] rounded-xl border border-gray-200 bg-white p-2 shadow-lg"
                >
                    <DropdownMenu.Group>
                        <DropdownMenu.Label className="px-3 py-2 text-xs font-medium text-[#7a8292]">
                            Apps
                        </DropdownMenu.Label>
                        {popularApps.map((app) => (
                            <DropdownMenu.Item
                                key={app.id}
                                className={appStoreItemClass}
                                onSelect={() => handleAppSelect(app.id)}
                            >
                                <AppStoreMenuItem
                                    title={app.title}
                                    description={app.description}
                                    iconClassName={app.iconClassName}
                                    iconChildren={app.iconChildren}
                                    link={app.link}
                                />
                            </DropdownMenu.Item>
                        ))}
                    </DropdownMenu.Group>


                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};

export default AppStore;
